var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerticalDotMenu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 14,
    fill: "none",
    viewBox: "0 0 4 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6A6A6A",
    stroke: "#6A6A6A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M2.074 6.681a.53.53 0 0 1-.537.521.53.53 0 0 1-.537-.52.53.53 0 0 1 .537-.522.53.53 0 0 1 .537.521Zm0-5.16a.53.53 0 0 1-.537.521.53.53 0 0 1-.537-.52A.53.53 0 0 1 1.537 1a.53.53 0 0 1 .537.521Zm0 10.32a.53.53 0 0 1-.537.522A.53.53 0 0 1 1 11.84a.53.53 0 0 1 .537-.52.53.53 0 0 1 .537.52Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalDotMenu);
export default __webpack_public_path__ + "static/media/vertical-dot-menu.cb0a9f84a11fd47b8e0734ae3239b13d.svg";
export { ForwardRef as ReactComponent };